import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { CardNumberElement, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useMemo, useState } from "react";
import { StripeCreditCardForm } from "../StripeCreditCardForm";

/**
 * Stripe payment gateway.
 */
var StripePaymentGateway = function StripePaymentGateway(_ref) {
  var _config$find;

  var config = _ref.config,
      processPayment = _ref.processPayment,
      formRef = _ref.formRef,
      formId = _ref.formId,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      onError = _ref.onError;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      submitErrors = _useState2[0],
      setSubmitErrors = _useState2[1];

  var apiKey = (_config$find = config.find(function (_ref2) {
    var field = _ref2.field;
    return field === "api_key";
  })) === null || _config$find === void 0 ? void 0 : _config$find.value;
  var stripePromise = useMemo(function () {
    if (apiKey) {
      return loadStripe(apiKey);
    }

    var stripeApiKeyErrors = [{
      message: "Stripe gateway misconfigured. Api key not provided."
    }];
    setSubmitErrors(stripeApiKeyErrors);
    onError(stripeApiKeyErrors);
    return null;
  }, [apiKey]);

  var handleFormSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stripe, elements) {
      var cartNumberElement, payload, _errors, _payload$paymentMetho, card, id, stripePayloadErrors, stripeElementsErrors;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cartNumberElement = elements === null || elements === void 0 ? void 0 : elements.getElement(CardNumberElement);

              if (!cartNumberElement) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return stripe === null || stripe === void 0 ? void 0 : stripe.createPaymentMethod({
                card: cartNumberElement,
                type: "card"
              });

            case 4:
              payload = _context.sent;

              if (payload === null || payload === void 0 ? void 0 : payload.error) {
                _errors = [_objectSpread({}, payload.error, {
                  message: payload.error.message || ""
                })];
                setSubmitErrors(_errors);
                onError(_errors);
              } else if (payload === null || payload === void 0 ? void 0 : payload.paymentMethod) {
                _payload$paymentMetho = payload.paymentMethod, card = _payload$paymentMetho.card, id = _payload$paymentMetho.id;

                if ((card === null || card === void 0 ? void 0 : card.brand) && (card === null || card === void 0 ? void 0 : card.last4)) {
                  processPayment(id, {
                    brand: card === null || card === void 0 ? void 0 : card.brand,
                    expMonth: (card === null || card === void 0 ? void 0 : card.exp_month) || null,
                    expYear: (card === null || card === void 0 ? void 0 : card.exp_year) || null,
                    firstDigits: null,
                    lastDigits: card === null || card === void 0 ? void 0 : card.last4
                  });
                }
              } else {
                stripePayloadErrors = [{
                  message: "Payment submission error. Stripe gateway returned no payment method in payload."
                }];
                setSubmitErrors(stripePayloadErrors);
                onError(stripePayloadErrors);
              }

              _context.next = 11;
              break;

            case 8:
              stripeElementsErrors = [{
                message: "Stripe gateway improperly rendered. Stripe elements were not provided."
              }];
              setSubmitErrors(stripeElementsErrors);
              onError(stripeElementsErrors);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFormSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var allErrors = [].concat(_toConsumableArray(errors), _toConsumableArray(submitErrors));
  return React.createElement("div", {
    "data-test": "stripeGateway"
  }, React.createElement(Elements, {
    stripe: stripePromise
  }, React.createElement(StripeCreditCardForm, {
    formId: formId,
    formRef: formRef,
    errors: allErrors,
    onSubmit: handleFormSubmit
  })));
};

export { StripePaymentGateway };